export default __webpack_public_path__ + "static/media/Mix-it.d7996669.svg";